import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Esta avaliação será analisada, e se for inadequada será removida. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingContainer = _resolveComponent("LoadingContainer")!
  const _component_RatingItem = _resolveComponent("RatingItem")!
  const _component_TextAreaInput = _resolveComponent("TextAreaInput")!
  const _component_FormButton = _resolveComponent("FormButton")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoadingContainer, { key: 0 }))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.ratings, (rating, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createVNode(_component_RatingItem, {
              rating: rating,
              onHandleRemove: _cache[0] || (_cache[0] = (id) => _ctx.onRemove(id)),
              onHandleChange: 
            async (item) => await _ctx.handleChange(item, index)
          
            }, null, 8, ["rating", "onHandleChange"])
          ]))
        }), 128)),
    _createVNode(_component_ModalComponent, {
      title: "Deseja reportar esta avaliação?",
      id: "report_rating_modal",
      backdrop: "false"
    }, {
      body: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_TextAreaInput, {
          class: "mb-0",
          model: _ctx.v$.form.reason_report,
          placeholder: "Qual motivo deseja reportar?",
          maxLength: 200
        }, null, 8, ["model"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_FormButton, {
          color: "danger",
          fullWidth: "",
          form: _ctx.v$.form,
          loading: _ctx.submitting,
          onOnClick: _ctx.handleConfirmReport,
          label: "Reportar",
          disabled: _ctx.v$.$invalid
        }, null, 8, ["form", "loading", "onOnClick", "disabled"])
      ]),
      _: 1
    })
  ]))
}